import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CategoryManager = ({ categories, onAddCategory, onEditCategory, onDeleteCategory }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const handleAdd = () => {
    if (newCategoryName?.trim()) {
      onAddCategory(newCategoryName?.trim());
      setNewCategoryName('');
      setIsAdding(false);
    }
  };

  const handleEdit = (id) => {
    if (editValue?.trim()) {
      onEditCategory(id, editValue?.trim());
      setEditingId(null);
      setEditValue('');
    }
  };

  const startEdit = (category) => {
    setEditingId(category?.id);
    setEditValue(category?.name);
  };

  return (
    <div className="category-manager bg-card border border-border rounded-lg p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Menu Categories
        </h3>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsAdding(!isAdding)}
          iconName={isAdding ? 'X' : 'Plus'}
          iconPosition="left"
          iconSize={16}
        >
          {isAdding ? 'Cancel' : 'Add'}
        </Button>
      </div>
      {isAdding && (
        <div className="mb-4 p-3 bg-muted/30 rounded-lg">
          <Input
            type="text"
            placeholder="Enter category name"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e?.target?.value)}
            className="mb-2"
          />
          <Button
            variant="default"
            size="sm"
            onClick={handleAdd}
            iconName="Check"
            iconPosition="left"
            iconSize={16}
            fullWidth
          >
            Add Category
          </Button>
        </div>
      )}
      <div className="space-y-2">
        {categories?.map((category) => (
          <div
            key={category?.id}
            className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-smooth"
          >
            {editingId === category?.id ? (
              <div className="flex-1 flex items-center gap-2">
                <Input
                  type="text"
                  value={editValue}
                  onChange={(e) => setEditValue(e?.target?.value)}
                  className="flex-1"
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleEdit(category?.id)}
                  iconName="Check"
                  iconSize={18}
                  className="touch-target"
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setEditingId(null);
                    setEditValue('');
                  }}
                  iconName="X"
                  iconSize={18}
                  className="touch-target"
                />
              </div>
            ) : (
              <>
                <div className="flex items-center gap-3 flex-1">
                  <Icon name="Tag" size={18} color="var(--color-primary)" />
                  <span className="text-sm md:text-base font-body text-foreground">
                    {category?.name}
                  </span>
                  <span className="text-xs font-caption text-muted-foreground">
                    ({category?.itemCount} items)
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => startEdit(category)}
                    iconName="Edit"
                    iconSize={16}
                    className="touch-target"
                  />
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onDeleteCategory(category?.id)}
                    iconName="Trash2"
                    iconSize={16}
                    className="touch-target text-destructive hover:text-destructive"
                  />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryManager;